export class Team {
    constructor(
        id,
        name,
        league,
    ) {
        this.id = id;
        this.name = name;
        this.league = league;
    }
}